<template>
  <div class="container">
    <div class="common-margin-top text-center common-padding-top">
      <span class="font-25 font-weight-bold common-letter-spacing">立即获取企业专属的解决方案</span>
    </div>
    <div class="common-padding-top row">
      <div class="col col-12 text-center common-margin-bottom"><img :src="require('images/product/contact-line.png')" /></div>
      <div class="col col-12 col-md-3 col-lg-3 font-14">
        <img class="common-img-icon-m common-margin-right-1" :src="require('images/product/tel.png')">电话：400-046-8365
      </div>
      <div class="col col-12 col-md-4 col-lg-4 font-14">
        <img class="common-img-icon-m common-margin-right-1" :src="require('images/product/msg.png')">邮箱：wangtao@yindiankeji.com
      </div>
      <div class="col col-12 col-md-5 col-lg-5 font-12">
        <img class="common-img-icon-m common-margin-right-1" :src="require('images/product/addr.png')">地址：广州天河区林和西路167号 威尼国际写字楼2833-2836室
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommSolution',
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CommSolution.vue